export const TIME_AVAILABILITY_TYPES = {
  HORIZONTAL: 'horizontal',
  HORIZONTAL_WITH_DATE: 'horizontalWithDate',
  HORIZONTAL_SEARCH: 'horizontalSearch',
  HORIZONTAL_EDIT_RESERVATION: 'horizontalEditReservation',
};
